export const SELECT_SHOPPING_CENTER = 'SELECT_SHOPPING_CENTER';

export const selectShoppingCenter = shoppingCenter => ({
	type: SELECT_SHOPPING_CENTER,
	payload: shoppingCenter
});
